import { render, staticRenderFns } from "./attentionList.vue?vue&type=template&id=36b193b4&scoped=true"
import script from "./attentionList.vue?vue&type=script&lang=js"
export * from "./attentionList.vue?vue&type=script&lang=js"
import style0 from "./attentionList.vue?vue&type=style&index=0&id=36b193b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b193b4",
  null
  
)

export default component.exports